/* eslint-disable no-undef */
// Polyfills that must run before any other imports.
// This file should not import anything.

(() => {
  const g = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : {};
  // Avoid assigning to crypto if it's a read-only getter; fall back to a local object.
  let c = g.crypto;
  if (!c) {
    c = {};
    try {
      g.crypto = c;
    } catch (e) {
      // read-only; keep local c
    }
  }

  if (typeof c.getRandomValues !== "function") {
    c.getRandomValues = (arr) => {
      for (let i = 0; i < arr.length; i += 1) arr[i] = Math.floor(Math.random() * 256);
      return arr;
    };
  }

  if (typeof c.randomUUID !== "function") {
    c.randomUUID = () =>
      "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (ch) => {
        const r = c.getRandomValues(new Uint8Array(1))[0];
        return (Number(ch) ^ (r & (15 >> (Number(ch) / 4)))).toString(16);
      });
  }

  if (typeof g.randomUUID !== "function") {
    g.randomUUID = c.randomUUID;
  }
})();
